(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Organisation', Organisation);

    Organisation.$inject = ['$resource'];

    function Organisation ($resource) {
        var resourceUrl =  'api/organisations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
